import { render, staticRenderFns } from "./Adeletearea.vue?vue&type=template&id=41279ad1&scoped=true"
import script from "./Adeletearea.vue?vue&type=script&lang=js"
export * from "./Adeletearea.vue?vue&type=script&lang=js"
import style0 from "./Adeletearea.vue?vue&type=style&index=0&id=41279ad1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41279ad1",
  null
  
)

export default component.exports